<template>
    <div class="product-images-gallery">
        <div class="product-image-row mb-2 p-2 rounded" :class="{'alert alert-danger': media.action === 'delete', 'remove': media.action === 'delete'}" v-for="(media, mediaIndex) in medias" :key="media.uuid">
            <button v-if="media.action === 'delete'" class="btn btn-sm btn-outline-secondary" type="button" @click="unmarkMediaToDelete(mediaIndex)">
                Récupérer
            </button>
            <button v-else type="button" class="btn btn-sm btn-danger" @click="markMediaToDelete(mediaIndex)">
                Retirer
            </button>

            <img :src="media.preview_url || media.url" :alt="media.name">

            <a target="_blank" :href="media.original_url || media.url">
                Télécharger
            </a>

            <div v-if="media.action === 'delete'" class="d-inline-block">
                Cette image sera supprimée après l'enregistrement.
            </div>

            <div class="d-inline-block">
                <button v-if="mediaIndex > 0" type="button" class="btn btn-secondary btn-small" @click="setDefaultMedia(mediaIndex)">Mettre en avant</button>
            </div>

            <input type="hidden" :name="'images[' + media.uuid + '][uuid]'" :value="media.uuid">
            <input type="hidden" :name="'images[' + media.uuid + '][url]'" :value="media.preview_url || media.url">
            <input type="hidden" :name="'images[' + media.uuid + '][action]'" :value="media.action">
        </div>
        <div v-if="loading">
            <i class="fad fa-spinner fa-spin"></i> Envoi en cours...
        </div>
        <div v-else>
            <input type="file" @change="onChange" multiple>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ProductImagesGallery',

    props: {
        product: {
            type: Object,
            required: true,
        },
        images: {
            type: Array|Object,
        },
    },

    data() {
        let medias = this.images || [];
        if (!Array.isArray(this.images)) {
            medias = Object.values(this.images)
        }

        return {
            medias: medias,
            loading: false,
        }
    },

    computed: {

    },

    methods: {
        setDefaultMedia(indexToMoveFirst) {
            if (indexToMoveFirst > 0 && this.medias.length >= 2) {
                const mediaToMove = this.medias.splice(indexToMoveFirst, 1);
                this.medias.unshift(mediaToMove[0]);
            }
        },

        markMediaToDelete(mediaIndex) {
            if (this.medias[mediaIndex].action === 'add') {
                this.medias.splice(mediaIndex, 1)
            } else {
                this.medias[mediaIndex].action = 'delete';
            }
        },

        unmarkMediaToDelete(mediaIndex) {
            this.medias[mediaIndex].action = 'keep';
        },

        onChange(event) {
            let formData = new FormData();
            for (const file of event.target.files) {
                formData.append("images[]", file);
            }
            this.loading = true;
            axios.post("/espace-admin/produits/upload-images-tmp", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    if (data.files) {
                        for (const file of data.files) {
                            this.medias.push({
                                ...file,
                                action: 'add',
                                exists: false,
                                preview_url: file.url,
                                original_url: file.url,
                            })
                        }
                    }
                }
            })
            .catch((...args) => {
                console.log(args);
            })
            .finally(() => {
                this.loading = false;
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.product-image-row {

}

.product-image-row img {
    max-width: 100px;
    max-height: 100px;
}

.product-image-row.remove img {
    max-width: 20px;
    max-height: 20px;
}
</style>
